import { render, staticRenderFns } from "./VpsHostingComponent.vue?vue&type=template&id=ea8f6c64&scoped=true&"
import script from "./VpsHostingComponent.vue?vue&type=script&lang=js&"
export * from "./VpsHostingComponent.vue?vue&type=script&lang=js&"
import style0 from "./VpsHostingComponent.vue?vue&type=style&index=0&id=ea8f6c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8f6c64",
  null
  
)

export default component.exports